import { staticConfig } from '@src/config/static';

// Intentional static config. This needs to work even if we fail to load the entire config
export function enterMaintenance(): void {
    redirectWithoutBackOption(staticConfig.countrySpecific.maintenance.defaultMaintenanceUrl);
}

export function redirectWithBackOption(url: string): void {
    window.location.href = url;
}

export function redirectWithoutBackOption(url: string): void {
    window.location.replace(url);
}
